import { Service } from '../service/types';
import { InvestmentServiceDetails } from './types';

export function serviceToInvestmentServiceDetail(
  service: Service,
): InvestmentServiceDetails {
  return {
    ownerVerified: service.ownerVerified,
    category: service.category,
    isIndex: service.isIndex,
    serviceName: service.name,
    serviceLogo: service.logo,
    serviceId: service.id,
    ssc: service.ssc,
  };
}
